// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.commonTwoColumnCollapser{
    display: flex;
    /*height: 100px;*/
    height: 100%;
    width: 100%;
}

.commonTwoColumnCollapser_side{
    display: flex;
    transition-duration: 400ms;
    /*transition-timing-function: linear;*/
    width: 100%;
    position: relative;
    transition-delay: 400ms;
}

.commonTwoColumnCollapser_left{
    /*min-width: 50px;*/
    /*background: #f99;*/
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.commonTwoColumnCollapser_right{
    /*min-width: 50px;*/
    /*background: #09f;*/
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.commonTwoColumnCollapser--both{
    .commonTwoColumnCollapser_left{
        width: 100%;
        transition-delay: 0ms;
    }
    
    .commonTwoColumnCollapser_right{
        width: 100%;
        transition-delay: 0ms;
    }
}

.commonTwoColumnCollapser--left{
    .commonTwoColumnCollapser_left{
        /*width: 100%;*/
        transition-delay: 0ms;
    }
    
    .commonTwoColumnCollapser_right{
        width: 0px;
    }
}

.commonTwoColumnCollapser--right{
    .commonTwoColumnCollapser_left{
        width: 0px;
    }
    
    .commonTwoColumnCollapser_right{
        /*width: 100%;*/
        transition-delay: 0ms;
    }
}

.commonTwoColumnCollapser_content{
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow: hidden;
    /*border: 1px solid #000;
    background-color: #0009;*/
    position: absolute;
    transition-duration: 400ms;
    /*transition-timing-function: linear;*/
    transition-delay: 200ms;
}

.commonTwoColumnCollapser_left .commonTwoColumnCollapser_content{
    right: 0%;
}

.commonTwoColumnCollapser_right .commonTwoColumnCollapser_content{
    left: 0%;
}

.commonTwoColumnCollapser--left{
    .commonTwoColumnCollapser_left .commonTwoColumnCollapser_content{
        right: 0%;
    }
    
    .commonTwoColumnCollapser_right .commonTwoColumnCollapser_content{
        left: 100%;
        transition-delay: 0ms;
    }
}

.commonTwoColumnCollapser--right{
    .commonTwoColumnCollapser_left .commonTwoColumnCollapser_content{
        right: 100%;
        transition-delay: 0ms;
    }
    
    .commonTwoColumnCollapser_right .commonTwoColumnCollapser_content{
        left: 0%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/twoColumnCollapser/TwoColumnCollapser.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,sCAAsC;IACtC,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB;6BACyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":["\n.commonTwoColumnCollapser{\n    display: flex;\n    /*height: 100px;*/\n    height: 100%;\n    width: 100%;\n}\n\n.commonTwoColumnCollapser_side{\n    display: flex;\n    transition-duration: 400ms;\n    /*transition-timing-function: linear;*/\n    width: 100%;\n    position: relative;\n    transition-delay: 400ms;\n}\n\n.commonTwoColumnCollapser_left{\n    /*min-width: 50px;*/\n    /*background: #f99;*/\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n}\n\n.commonTwoColumnCollapser_right{\n    /*min-width: 50px;*/\n    /*background: #09f;*/\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n}\n\n.commonTwoColumnCollapser--both{\n    .commonTwoColumnCollapser_left{\n        width: 100%;\n        transition-delay: 0ms;\n    }\n    \n    .commonTwoColumnCollapser_right{\n        width: 100%;\n        transition-delay: 0ms;\n    }\n}\n\n.commonTwoColumnCollapser--left{\n    .commonTwoColumnCollapser_left{\n        /*width: 100%;*/\n        transition-delay: 0ms;\n    }\n    \n    .commonTwoColumnCollapser_right{\n        width: 0px;\n    }\n}\n\n.commonTwoColumnCollapser--right{\n    .commonTwoColumnCollapser_left{\n        width: 0px;\n    }\n    \n    .commonTwoColumnCollapser_right{\n        /*width: 100%;*/\n        transition-delay: 0ms;\n    }\n}\n\n.commonTwoColumnCollapser_content{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    /*border: 1px solid #000;\n    background-color: #0009;*/\n    position: absolute;\n    transition-duration: 400ms;\n    /*transition-timing-function: linear;*/\n    transition-delay: 200ms;\n}\n\n.commonTwoColumnCollapser_left .commonTwoColumnCollapser_content{\n    right: 0%;\n}\n\n.commonTwoColumnCollapser_right .commonTwoColumnCollapser_content{\n    left: 0%;\n}\n\n.commonTwoColumnCollapser--left{\n    .commonTwoColumnCollapser_left .commonTwoColumnCollapser_content{\n        right: 0%;\n    }\n    \n    .commonTwoColumnCollapser_right .commonTwoColumnCollapser_content{\n        left: 100%;\n        transition-delay: 0ms;\n    }\n}\n\n.commonTwoColumnCollapser--right{\n    .commonTwoColumnCollapser_left .commonTwoColumnCollapser_content{\n        right: 100%;\n        transition-delay: 0ms;\n    }\n    \n    .commonTwoColumnCollapser_right .commonTwoColumnCollapser_content{\n        left: 0%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
